import { useXHR } from "@sembark-travel/xhr"
import {
	NewPayUIntegrationForm,
	type TIntegration,
} from "../../../../Integrations"
import { Box, Container } from "@sembark-travel/ui/base"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"
import { showSnackbar } from "@sembark-travel/ui/snackbar"

export default function NewPayUIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New PayU Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New PayU Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					["", "PayU Integrations"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewPayUIntegrationForm
								initialValues={{
									name: "PayU Payment Solutions",
									description: "Manage Payments using PayU",
								}}
								onSubmit={async (values) => {
									const integration = await xhr
										.post<{ data: TIntegration }>("integrations", {
											...values,
										})
										.then((resp) => resp.data.data)
									showSnackbar("Integration created successfully.")
									navigate("/integrations/:integrationId/pg/configuration", {
										params: {
											integrationId: String(integration.uid),
										},
										replace: true,
									})
								}}
								onCancel={() => {
									navigate("/org/integrations", { replace: true })
								}}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
